import { LocalizedError } from '@/core/i18n';
import { fetchImagePixels } from '@/core/network';
import { demTileUrl } from './demTiles';
import { decodeTerrarium } from './terrarium';

/** Decoded elevation tiles (metres, row-major 256×256), shared by all computations. */
const cache = new Map<string, Promise<Float32Array>>();

export function loadElevationTile(z: number, x: number, y: number): Promise<Float32Array> {
  const key = `${z}/${x}/${y}`;
  let tile = cache.get(key);
  if (!tile) {
    tile = fetchImagePixels(demTileUrl(z, x, y)).then(
      (img) => decodeTerrarium(img.data),
      (err: unknown) => {
        cache.delete(key); // allow a retry
        throw new LocalizedError('elevation:errors.tileFailed', { tile: key }, { cause: err });
      },
    );
    cache.set(key, tile);
  }
  return tile;
}
